var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3928_6936",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.77308 8.40486C-0.182228 7.40692 -0.261408 5.85945 0.587054 4.76922L3.46257 1.07434C3.99013 0.396452 4.80103 0 5.66001 0H20.4629C21.3286 0 22.145 0.402658 22.672 1.0895L25.5015 4.77737C26.3364 5.86545 26.2546 7.39938 25.3089 8.39255L15.0785 19.1357C13.9832 20.286 12.149 20.2884 11.0507 19.141L0.77308 8.40486Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3928_6936)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.769318 6.66739L4.41952 0H21.957L27.0725 6.66739L13.1882 21.2477L-0.769318 6.66739Z",
    fill: "url(#paint0_linear_3928_6936)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.769348 6.66504L5.65625 8.78688L13.1882 21.2454L-0.769348 6.66504Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0369 6.66504L20.5044 8.78688L13.1878 21.2454L27.0369 6.66504Z",
    fill: "black",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0813 1.4551L4.36238 -0.00585938L5.65629 8.7863H13.0446H13.1179H20.5048L21.7987 -0.00585938L13.0813 1.4551Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36238 -0.00585938L13.1882 2.92486L21.957 -0.00292866L4.36238 -0.00585938Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0813 1.45312L5.65633 8.78432H20.5048L13.0813 1.45312Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1883 2.92383L5.65633 8.78527H20.5048L13.1883 2.92383Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65625 8.7863L-0.769348 6.66446L4.36234 -0.00585938H5.65625V8.7863Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5049 8.7863L27.0755 6.66446L21.9439 -0.00585938H20.6499L20.5049 8.7863Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65633 8.78711L13.1516 21.2266L20.5048 8.78711H5.65633Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3928_6936",
    x1: 13.1516,
    y1: 0,
    x2: 13.1516,
    y2: 21.2477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#003B95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D1FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.89b23b58c05e043b25ed0fd12621bd38.svg";
export { ForwardRef as ReactComponent };